export function getFeaturesFromUrl(): Record<string, unknown> {
    const featuresFromUrl = new URLSearchParams(getSearchParamsFromUrl()).get('features');

    if (!featuresFromUrl) {
        return {};
    }
    return JSON.parse(featuresFromUrl);
}

function getSearchParamsFromUrl(): string {
    const redirectUrl = sessionStorage.getItem('redirect');
    if (!redirectUrl) {
        return window.location.search;
    }

    return new URL(redirectUrl).search;
}
